import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: "mdi",
    theme: {
        dark: true,
        themes: {
            light: {
                primary: "#A37CB4",
                secondary: "#CC8DB7",
                accent: "#CB93BB",
                warning: "#BC5F86",
                info: "#EFE9EE"
            },
            dark: {
                primary: "#35233D",
                accent: "#803D6D",
                secondary: "#7D3866",
                info: "#DED1DB",
                warning: "#261019"
            }
        }
    },
});
